export default __webpack_public_path__ + "static/fs-logo-170cf7eab3cbda000dedcafd8b4d0ffd.png";